export default "__VITE_ASSET__Tvw2g2$f__"